// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/bg_img.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionExpired_container__\\+HJTD {
  display: flex;
  flex-direction: column;
  background-color: var(--color-light);
  align-items: center;
  width: 100vw;
  height: 100%;
  padding: 3rem 8rem;
}
@media only screen and (max-width: 43.75em) {
  .SubscriptionExpired_container__\\+HJTD {
    padding: 3rem;
  }
}
.SubscriptionExpired_container__\\+HJTD > :first-child {
  align-self: stretch;
}

.SubscriptionExpired_topside__nR5h7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.SubscriptionExpired_topside_1__aB3bm {
  display: flex;
  align-items: center;
}
.SubscriptionExpired_topside_1__aB3bm > :not(:last-child) {
  margin-right: 3rem;
}
.SubscriptionExpired_topside_welcome__10lQm {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.SubscriptionExpired_topside_name__X-jR\\+ {
  color: var(--color-primary);
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  line-height: 3rem;
}
.SubscriptionExpired_topside_icon__nWexB {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .SubscriptionExpired_topside_icon__nWexB {
    margin-bottom: 1rem;
  }
}
.SubscriptionExpired_topside_icon_main__BiLPO {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .SubscriptionExpired_topside_icon_main__BiLPO {
    flex-direction: column-reverse;
  }
}

.SubscriptionExpired_banner__DQ99A {
  display: grid;
  grid-template-columns: 1fr 40%;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .SubscriptionExpired_banner__DQ99A {
    grid-template-columns: 40% 1fr;
  }
}
@media only screen and (max-width: 50em) {
  .SubscriptionExpired_banner__DQ99A {
    grid-template-columns: 1fr;
  }
}
.SubscriptionExpired_banner__walletBg__bzoD4 {
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: var(--color-white);
  box-sizing: border-box;
  padding: 2rem;
}

.SubscriptionExpired_balance__side__78beZ {
  display: flex;
  justify-content: space-between;
}
.SubscriptionExpired_balance__amount__nj\\+ea {
  display: flex;
  flex-direction: column;
}
.SubscriptionExpired_balance__btns__EQJow {
  padding-left: 1rem;
}

.SubscriptionExpired_selectCurrency__96tBH {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.SubscriptionExpired_selectCurrency__text__c9YWe {
  display: flex;
  margin-left: 1rem;
}
.SubscriptionExpired_selectCurrency__icon__I10e7 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 3rem;
  height: 3rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.SubscriptionExpired_selectCurrency__icon__I10e7:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.SubscriptionExpired_selectCurrency__icon_active__HjAkP {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 3rem;
  height: 3rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.SubscriptionExpired_selectCurrency__list__C85li {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.SubscriptionExpired_selectCurrency__list_active__MRDCj {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.SubscriptionExpired_selectCurrency__list__C85li li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.SubscriptionExpired_selectCurrency__list__C85li li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.SubscriptionExpired_subImg__krqT5 {
  width: 28rem;
  margin: 4rem 0;
}

.SubscriptionExpired_logo__oDAGA {
  height: 3.8rem;
  margin-bottom: 3rem;
}

.SubscriptionExpired_btns__usJaN {
  display: grid;
  grid-template-columns: 1000%;
  gap: 3rem;
  padding-bottom: 4rem;
}
.SubscriptionExpired_btns__btn__5bwwa {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  border: 1px solid var(--color-primary);
  border-radius: 0.8rem;
  padding: 3rem;
  width: 40rem;
  cursor: pointer;
  transition: all 0.2s;
}
@media only screen and (max-width: 56.25em) {
  .SubscriptionExpired_btns__btn__5bwwa {
    width: 38rem;
  }
}
.SubscriptionExpired_btns__btn__5bwwa:hover {
  background-color: var(--color-primary-3);
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  font-weight: 700;
  transition: all 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Onboarding/SubscriptionExpired.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AADF;AAGE;EATF;IAUI,aAAA;EAAF;AACF;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,kBAAA;AADN;AAKE;EACE,oCAAA;EACA,mBAAA;AAHJ;AAME;EACE,2BAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;AALJ;AAOI;EAJF;IAKI,mBAAA;EAJJ;AACF;AAMI;EACE,aAAA;EACA,mBAAA;AAJN;AAMM;EAJF;IAKI,8BAAA;EAHN;AACF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,sBAAA;AALF;AAOE;EAXF;IAYI,8BAAA;EAJF;AACF;AAME;EAfF;IAgBI,0BAAA;EAHF;AACF;AAKE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;AAHJ;;AAQE;EACE,aAAA;EACA,8BAAA;AALJ;AAQE;EACE,aAAA;EACA,sBAAA;AANJ;AASE;EACE,kBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AARF;AAUE;EACE,aAAA;EACA,iBAAA;AARJ;AAWE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AATJ;AAWI;EACE,4DACE;EAEF,wCAAA;EACA,2BAAA;AAXN;AAcI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACE;EAEF,wCAAA;EACA,2BAAA;AAdN;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACE;EAEF,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAlBJ;AAoBI;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAlBN;AAqBI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAnBN;AAqBM;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAnBR;;AAyBA;EACE,YAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,4BAAA;EACA,SAAA;EACA,oBAAA;AAtBF;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,sCAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AA3BJ;AA6BI;EAXF;IAYI,YAAA;EA1BJ;AACF;AA4BI;EACE,wCAAA;EACA,sCAAA;EACA,2BAAA;EACA,gBAAA;EACA,oBAAA;AA1BN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.container {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-light);\n  align-items: center;\n  width: 100vw;\n  height: 100%;\n  padding: 3rem 8rem;\n\n  @media only screen and (max-width: $bp-700) {\n    padding: 3rem;\n  }\n\n  &> :first-child {\n    align-self: stretch;\n  }\n}\n\n.topside {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n\n  &_1 {\n    display: flex;\n    align-items: center;\n\n    &> :not(:last-child) {\n      margin-right: 3rem;\n    }\n  }\n\n  &_welcome {\n    font-size: var(--default-font-small);\n    line-height: 1.8rem;\n  }\n\n  &_name {\n    color: var(--color-primary);\n    font-size: var(--default-font-subtitle);\n    font-weight: 700;\n    line-height: 3rem;\n  }\n\n  &_icon {\n    display: flex;\n    align-items: center;\n\n    @media only screen and (max-width: $bp-500) {\n      margin-bottom: 1rem;\n    }\n\n    &_main {\n      display: flex;\n      align-items: center;\n\n      @media only screen and (max-width: $bp-500) {\n        flex-direction: column-reverse;\n      }\n    }\n  }\n}\n\n.banner {\n  display: grid;\n  grid-template-columns: 1fr 40%;\n  gap: 2rem;\n  padding: 2rem;\n  align-items: center;\n  width: 100%;\n  background-image: url(\"../../img/bg_img.svg\");\n  background-size: cover;\n  box-sizing: border-box;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 40% 1fr;\n  }\n\n  @media only screen and (max-width: $bp-800) {\n    grid-template-columns: 1fr;\n  }\n\n  &__walletBg {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    background-color: var(--color-white);\n    box-sizing: border-box;\n    padding: 2rem;\n  }\n}\n\n.balance {\n  &__side {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__amount {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__btns {\n    padding-left: 1rem;\n  }\n}\n\n.selectCurrency {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: var(--default-font-small);\n  position: relative;\n  margin-left: 2rem;\n\n  &__text {\n    display: flex;\n    margin-left: 1rem;\n  }\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 3rem;\n    background-color: #f2f0f0;\n    color: var(--color-primary);\n    width: 3rem;\n    height: 3rem;\n    border-radius: 5rem;\n    border: solid 1px var(--color-primary-4);\n    cursor: pointer;\n    transform: rotateZ(0);\n    transition-duration: 500ms;\n\n    &:hover {\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n\n    &_active {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 3rem;\n      background-color: #f2f0f0;\n      color: var(--color-primary);\n      width: 3rem;\n      height: 3rem;\n      border-radius: 5rem;\n      border: solid 1px var(--color-primary-4);\n      cursor: pointer;\n      transition-duration: 500ms;\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    width: 5rem;\n    background-color: #f2f0f0;\n    color: var(--color-dark);\n    border-radius: 1rem;\n    box-shadow:\n      10px 10px 45px #bebebe,\n      -15px -15px 30px #ffffff;\n    position: absolute;\n    top: 6rem;\n    z-index: 30;\n    border: solid 1px var(--color-primary-4);\n\n    &_active {\n      background-color: var(--color-primary-7);\n      color: var(--color-primary);\n      font-weight: 700;\n    }\n\n    li {\n      list-style: none;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      border-radius: 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-primary-7);\n        color: var(--color-primary);\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n.subImg {\n  width: 28rem;\n  margin: 4rem 0;\n}\n\n.logo {\n  height: 3.8rem;\n  margin-bottom: 3rem;\n}\n\n.btns {\n  display: grid;\n  grid-template-columns: 1000%;\n  gap: 3rem;\n  padding-bottom: 4rem;\n\n  // @media only screen and (max-width: $bp-900) {\n  //   grid-template-columns: 1fr;\n  //   gap: 3rem;\n  // }\n\n  &__btn {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--color-white);\n    border: 1px solid var(--color-primary);\n    border-radius: 0.8rem;\n    padding: 3rem;\n    width: 40rem;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    @media only screen and (max-width: $bp-900) {\n      width: 38rem;\n    }\n\n    &:hover {\n      background-color: var(--color-primary-3);\n      border: 2px solid var(--color-primary);\n      color: var(--color-primary);\n      font-weight: 700;\n      transition: all 0.2s;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SubscriptionExpired_container__+HJTD`,
	"topside": `SubscriptionExpired_topside__nR5h7`,
	"topside_1": `SubscriptionExpired_topside_1__aB3bm`,
	"topside_welcome": `SubscriptionExpired_topside_welcome__10lQm`,
	"topside_name": `SubscriptionExpired_topside_name__X-jR+`,
	"topside_icon": `SubscriptionExpired_topside_icon__nWexB`,
	"topside_icon_main": `SubscriptionExpired_topside_icon_main__BiLPO`,
	"banner": `SubscriptionExpired_banner__DQ99A`,
	"banner__walletBg": `SubscriptionExpired_banner__walletBg__bzoD4`,
	"balance__side": `SubscriptionExpired_balance__side__78beZ`,
	"balance__amount": `SubscriptionExpired_balance__amount__nj+ea`,
	"balance__btns": `SubscriptionExpired_balance__btns__EQJow`,
	"selectCurrency": `SubscriptionExpired_selectCurrency__96tBH`,
	"selectCurrency__text": `SubscriptionExpired_selectCurrency__text__c9YWe`,
	"selectCurrency__icon": `SubscriptionExpired_selectCurrency__icon__I10e7`,
	"selectCurrency__icon_active": `SubscriptionExpired_selectCurrency__icon_active__HjAkP`,
	"selectCurrency__list": `SubscriptionExpired_selectCurrency__list__C85li`,
	"selectCurrency__list_active": `SubscriptionExpired_selectCurrency__list_active__MRDCj`,
	"subImg": `SubscriptionExpired_subImg__krqT5`,
	"logo": `SubscriptionExpired_logo__oDAGA`,
	"btns": `SubscriptionExpired_btns__usJaN`,
	"btns__btn": `SubscriptionExpired_btns__btn__5bwwa`
};
export default ___CSS_LOADER_EXPORT___;
